import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ADD_USER, GET_USER } from '../../query/queries';
import { addUser } from '../../actions';

import styles from './Home.css';

const mapDispatchToProps = dispatch => {
  return {
    addUser: user => dispatch(addUser(user))
  };
};

const ConnectedHome = withRouter(class ConnectedHome extends Component {
  state = {
    username: '',
    photoUrl: '',
    error: false,
  }

  getUser = (username) => (
    new ApolloClient({
      link: new HttpLink({
        uri: process.env.REACT_APP_GRAPHQL_URI
      }),
      cache: new InMemoryCache(),
      connectToDevTools: process.env.NODE_ENV === 'development',
      dataIdFromObject: o => o.id
    }).query({
      query: GET_USER,
      variables: { username },
    })
  );

  updateUsername = (event) => {
    const username = event.target.value;
    this.setState({
      username,
    });
  }

  updatePhotoUrl = (event) => {
    const photoUrl = event.target.value;
    this.setState({
      photoUrl,
    });
  }

  existsUser = (userList) => {
    return userList.length !== 0;
  }

  login = (createUser) => async () => {
    const username = this.state.username.trim();
    const photoUrl = this.state.photoUrl;
    if (!username) {
      this.setState({
        error: true,
      });
    } else {
      const responseGetUsers = await this.getUser(username);
      if (!this.existsUser(responseGetUsers.data.allUsers)) {
        try {
          const theme = 'LIGHT';
          const response = await createUser({ variables: { username, photoUrl } });
          const user = response.data.createUser;
          this.props.addUser({ id: user.id, username: user.username, photoUrl: user.photoUrl, theme });
        } catch (error) {
          alert('Oops! Ha ocurrido un error. Intentelo de nuevo');
        }
      } else {
        const user = responseGetUsers.data.allUsers[0];
        this.props.addUser({ id: user.id, username: user.username, photoUrl: user.photoUrl, theme: user.theme });
      }
      this.props.history.push('/chats');
    }
  }

  render() {
    return (
      <Mutation mutation={ADD_USER}>
        {createUser => (
          <div className={styles.heroContainer}>
            <div className={styles.mainContainer}>
              <label className={styles.title}>CoolChat</label>
              <label className={styles.text}>¡Bienvenido!</label>
              <label className={styles.text}>Acaba de entrar al mejor sitio de mensajería instantánea.</label>
              <label className={styles.text}>Solo necesita ingresar su nombre (y si una foto de perfil si lo desea) y ponerse a mensajear</label>
              <div className={styles.dataContainer}>
                <input type='text' className={styles.inputName} onChange={(e) => this.updateUsername(e)} placeholder='Nombre*' />
                <input type='text' className={styles.inputName} onChange={(e) => this.updatePhotoUrl(e)} placeholder='URL de foto de perfil' />
                <button className={styles.buttonSubmit} onClick={this.login(createUser)}><span>INGRESAR</span></button>
                {
                  this.state.error &&
                  <label className={styles.errorLabel}>Por favor, ingrese un nombre</label>
                }
              </div>
            </div>
          </div>)}
      </Mutation>
    );
  }
})

const Home = connect(null, mapDispatchToProps)(ConnectedHome);

export default Home;


// WEBPACK FOOTER //
// ./src/pages/home/Home.jsx